export default __webpack_public_path__ + "static/media/redArrow.af917d8b.svg";